<script>
import { Helper } from '@/mixin/helper'
import McGraphqlEditableTable from '@/components/McGraphqlEditableTable'
import {
  GET_THERMO,
  THERMO_MUTATION_CREATE,
  THERMO_MUTATION_DELETE,
  THERMO_MUTATION_UPDATE,
} from '@/services/api/setting/fleet/thermoType'

export default {
  components: { McGraphqlEditableTable },
  mixins: [Helper],
  props: {
    status: String,
  },
  data() {
    return {
      data: [],
    }
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          inputName: 'thermoName',
          label: this.$t('setting.list.fleetSetting.termoType'),
          placeholder: this.$t('setting.list.fleetSetting.termoType'),
          thClass: 'mc-table--50',
          isSortable: true,
          editable: true,
          validation: [['required'], ['isUnique', this.data]],
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          if (filter?.orderBy) {
            let objOrderBy = JSON.parse(filter.orderBy[0])
            let optOrderBy = {
              text: objOrderBy.name,
            }
            delete filter.orderBy[0]
            filter.orderBy[0] = JSON.stringify(optOrderBy)
          }
          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_THERMO,
            variables: {
              filter: filter,
            },
          })
          let self = this
          let result = res.data.thermoTypes.thermoTypes
          result.data.forEach((item, index) => {
            if (item.companyId == 1) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = false
            } else if (item.hasRelation) {
              result.data[index].disableCheckbox = true
              result.data[index].isShowEdit = true
            }
            result.data[index].name = item.text
          })

          self.data = result.data
          return result
        },
        store: async (data) => {
          const res = await this.$apollo.mutate({
            mutation: THERMO_MUTATION_CREATE,
            variables: {
              input: {
                text: data.thermoName,
              },
            },
          })
          let self = this
          let newData = res.data.createThermoType.thermoType
          newData.name = data.thermoName
          self.data.push(newData)

          return newData
        },
        update: async (name, oldData, newData) => {
          const res = await this.$apollo.mutate({
            mutation: THERMO_MUTATION_UPDATE,
            variables: {
              input: {
                oldValue: oldData.name,
                newValue: newData.thermoName,
              },
            },
          })
          let self = this
          let dataUpdateIndex = self.data.findIndex((item) => item.name == name)
          let result = res.data.updateThermoType.thermoType
          result.name = newData.thermoName
          self.data[dataUpdateIndex] = result
          return result
        },
        delete: async (name) => {
          const res = await this.$apollo.mutate({
            mutation: THERMO_MUTATION_DELETE,
            variables: {
              input: {
                text: name,
              },
            },
          })

          return res.data.deleteThermoType.isSuccessful
        },
      }
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', this.status)
  },
}
</script>

<template>
  <!-- Rekrutmen -->
  <b-tab class="border-0" @click="$store.commit('setting/SET_STATUS', status)">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.fleetSetting.termoType') }}</span>
    </template>

    <!-- Table -->
    <div class="table-responsive my-3">
      <McGraphqlEditableTable
        :fields="fields"
        :apiClient="query"
        trackBy="text"
        :searchable="true"
        :isPredefined="true"
      />
    </div>
  </b-tab>
</template>
